<mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  [selectedIndex]="selectedTabIndex()"
  (selectedIndexChange)="onTabChange($event)"
>
  <mat-tab label="Disk Usage">
    @if (groupData) {
      <app-disk-usage
        [usage]="groupData.usage"
        [plan]="groupData.plan"
        (syncUsage)="syncWebsiteDiskUsage()"
      ></app-disk-usage>
    }
  </mat-tab>
  <mat-tab label="Bandwidth">
    @if (bandwidth$ | async; as bandwidth) {
      <app-bandwidth [bandwidth]="bandwidth" [plan]="groupData.plan"></app-bandwidth>
    }
  </mat-tab>
  <mat-tab label="CPU">
    @if (cpuUsage$ | async; as usage) {
      <app-cpu [usage]="usage" (selectedPeriodChange)="onPeriodChange($event)"></app-cpu>
    }
  </mat-tab>
</mat-tab-group>
